import BountySVG from '@public/icons/icon-marketplace-bounty.svg'
import ActivitySVG from '@public/icons/icon-marketplace-planet-activity.svg'
import ItemsSVG from '@public/icons/icon-marketplace-planet-items.svg'
import SharedThirdNavBar, {
  NavigationItem
} from '@src/components/navigationBar/third/SharedThirdNavBar'
import { ROUTE } from '@src/constants/route'
import { FC, useMemo } from 'react'

export const BAR_HEIGHT = 60

const ApostleThirdNavBar: FC<Props> = (props: Props) => {
  const { activeByRoute = true, index = 0 } = props

  const navigationItems: NavigationItem[] = useMemo(
    () => [
      {
        icon: ItemsSVG,
        route: ROUTE.MARKETPLACE_APOSTLE_LIST,
        translationKey: 'sub_bar.marketplace.tabs.items'
      },
      {
        icon: BountySVG,
        route: ROUTE.MARKETPLACE_APOSTLE_BOUNTY,
        translationKey: 'sub_bar.marketplace.tabs.bounties'
      },
      {
        icon: ActivitySVG,
        route: ROUTE.MARKETPLACE_APOSTLE_ACTIVITY_LIST,
        translationKey: 'sub_bar.marketplace.tabs.activities'
      }
    ],
    []
  )

  const currentIndex = activeByRoute
    ? navigationItems.findIndex(item =>
        item.route.startsWith(window.location.pathname)
      )
    : index

  return (
    <SharedThirdNavBar
      height={BAR_HEIGHT}
      index={currentIndex}
      navigationItems={navigationItems}
    />
  )
}

type Props = {
  index?: number
  activeByRoute?: boolean
}

export default ApostleThirdNavBar
